/**
 * Calls a rep joined with their own mic on a colleague's desktop call
 * (co-seller, owner decision D4 2026-10-05).
 *
 * The call is one session, credited to its owner. The rep's own Sessions list
 * shows it once, tagged "Joined <owner>'s call", and it opens read-only: no
 * edit controls, and no grade or coaching (the backend leaves them out). The
 * query flag mirrors salesguru-backend's `src/constants/coSellerHistory.js`;
 * change both together.
 */

/** Query flag that asks GET /admin/sessions to add the calls the viewer joined to their own list. */
export const INCLUDE_JOINED_PARAM = 'includeJoined';

export const CO_SELLER_CALL_COPY = {
  /** Used when the backend could not name the owner. */
  unknownOwner: 'a colleague',
  readOnlyNote: "You joined this call with your own mic. It is read-only, and its grade is the owner's.",
} as const;

/** The tag on a joined call: "Joined Olive Owner's call". */
export const formatJoinedCallTag = (ownerName: string | null | undefined): string =>
  `Joined ${ownerName?.trim() || CO_SELLER_CALL_COPY.unknownOwner}'s call`;
